import { signOut, onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../firebase';
import { setDoc, doc, getDoc } from 'firebase/firestore';

export const createUserDocument = async (user) => {
  const userDocRef = doc(db, 'users', user.uid);
  const userSnapshot = await getDoc(userDocRef);
  if (!userSnapshot.exists()) {
    await setDoc(userDocRef, {
      name: user.displayName || 'Nome Non Disponibile',
      email: user.email,
      picture: user.photoURL || '',
      createdAt: new Date(),
    });
  }
};

export const listenAuthState = (callback) => {
  return onAuthStateChanged(auth, callback);
};

export const handleLogout = async (navigate) => {
  try {
    await signOut(auth);
    navigate('/');
  } catch (error) {
    console.error('Errore durante il logout:', error);
  }
};
